module.exports = __webpack_public_path__ + "img/instagram.bc351b4e.svg";